import Vue from 'vue'
import VueI18n from 'vue-i18n'
import esValidator from 'vee-validate/dist/locale/es'
import ptValidator from 'vee-validate/dist/locale/pt_BR'
import VeeValidate from 'vee-validate'

export class Language {
  constructor () {
    this.messages = {}
    this.i18n = {}
    Vue.use(VueI18n)
  }

  retrieveMessages () {
    const response = window.$.ajax({ type: 'POST', url: '/api/languages/phrases', async: false })
    let messages = {}
    if (response.status === 200) {
      const data = response.responseJSON
      let languages = {}
      for (let i = 0; i < data.length; i++) {
        languages[data[i].locale] = {}
        let locale = languages[data[i].locale]
        const phrases = data[i].phrases.sort()
        for (let j = 0; j < phrases.length; j++) {
          locale[phrases[j].key] = phrases[j].value
        }
      }
      messages = languages
    }
    this.messages = messages
  }

  initialize (store) {
    this.retrieveMessages()
    this.initializei18n(store)
    this.initiaizeUses(store)
  }

  capitalize (i18n, value, arg = '') {
    value = i18n.t(value, i18n.lang, arg)
    if (value.charAt(0) !== '¿') {
      value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
    } else {
      value = value.charAt(0) + value.charAt(1).toUpperCase() + value.slice(2).toLowerCase()
    }
    return value
  }

  initializei18n (store) {
    const logged_in = store.state.authentication.logged_in
    const locale = store.state.authentication.user_data.language
    const self = this
    const i18n = new VueI18n({
      locale: (logged_in) ? locale : 'en',
      fallbackLocale: 'en',
      messages: this.messages,
      silentTranslationWarn: true
    })
    Vue.filter('translate', function (value, arg) {
      return i18n.t(value, i18n.lang, arg)
    })
    Vue.filter('titleize', function (value, arg) {
      value = i18n.t(value, i18n.lang, arg)
      let words = value.split(' ')
      for (let i = 0; i < words.length; i++) {
        if (words[i].length > 3 || i === 0) {
          words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase()
        }
      }
      return words.join(' ')
    })
    Vue.filter('capitalize', function (value, arg) {
      return self.capitalize(i18n, value, arg)
    })
    Vue.filter('subDates', function (value, arg) {
      let t = Math.abs(value - new Date().getTime())
      let days = Math.floor(t / (24 * 60 * 60 * 1000))
      let daysms = t % (24 * 60 * 60 * 1000)
      let hours = Math.floor((daysms) / (60 * 60 * 1000))
      let hoursms = t % (60 * 60 * 1000)
      let minutes = Math.floor((hoursms) / (60 * 1000))
      let minutesms = t % (60 * 1000)
      let sec = Math.floor((minutesms) / (1000))
      value = value - (new Date().getTime())
      let final_text = i18n.t('just_now')
      if (days > 0) {
        final_text = i18n.tc('day_filter', days, { num: days })
      } else if (hours > 0) {
        final_text = i18n.tc('hour_filter', hours, { num: hours })
      } else if (minutes > 0) {
        final_text = i18n.tc('minute_filter', minutes, { num: minutes })
      } else if (sec > 0) {
        final_text = i18n.tc('second_filter', sec, { num: sec })
      }
      return final_text
    })
    this.i18n = i18n
  }

  initiaizeUses (store) {
    const logged_in = store.state.authentication.logged_in
    const locale = store.state.authentication.user_data.language
    Vue.use(VeeValidate, {
      locale: (logged_in) ? locale : 'en',
      dictionary: {
        en: { attributes: this.messages.en },
        es: { messages: esValidator.messages, attributes: this.messages.es },
        pt: { messages: ptValidator.messages, attributes: this.messages.pt }
      }
    })
  }
}

export let language = new Language()



// WEBPACK FOOTER //
// app/javascript/src/languages/language.js